import { render, staticRenderFns } from "./TravelServiceMenu.vue?vue&type=template&id=d9fedf2c&scoped=true&"
import script from "./TravelServiceMenu.vue?vue&type=script&lang=js&"
export * from "./TravelServiceMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fedf2c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9fedf2c')) {
      api.createRecord('d9fedf2c', component.options)
    } else {
      api.reload('d9fedf2c', component.options)
    }
    module.hot.accept("./TravelServiceMenu.vue?vue&type=template&id=d9fedf2c&scoped=true&", function () {
      api.rerender('d9fedf2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/TravelService/TravelServiceMenu.vue"
export default component.exports